import React from "react";
import { Icon, Panel, Tooltip, Grid, classnames } from "@culturehq/components";

import { GetState } from "app/hooks/useGet";
import { formatThousand, t, Trans } from "app/utils";

import Change from "./Change";
import styles from "./event-status.module.scss";

type EventsStats = {
  total: number;
  change: number;
};

const TotalEvents: React.FC<{ events: EventsStats }> = ({ events }) => (
  <Panel>
    <Panel.Body className="tile_view">
      <div className={classnames(styles.icon, styles.green)}>
        <Icon icon="calendar-star" />
      </div>
      <h2>{formatThousand(events.total)}</h2>
      <div>
        <h4><Trans>Total Programs</Trans></h4>
      </div>
      <Change change={events.change} />
    </Panel.Body>
  </Panel>
);

type RsvpsStats = {
  total: number;
  change: number;
};

const TotalRsvps: React.FC<{ rsvps: RsvpsStats }> = ({ rsvps }) => (
  <Panel>
    <Panel.Body className="tile_view">
      <div className={classnames(styles.icon, styles.blue)}>
        <Icon icon="invitation" />
      </div>
      <h2>{formatThousand(rsvps.total)}</h2>
      <div>
        <h4><Trans>Total Engaged</Trans></h4>
      </div>
      <Change change={rsvps.change} />
    </Panel.Body>
  </Panel>
);

type ImpactStats = {
  score: number;
  change: number;
};

const Impact: React.FC<{ impact: ImpactStats }> = ({ impact }) => (
  <Panel>
    <Panel.Body className="tile_view">
      <div className={classnames(styles.icon, styles.yellow)}>
        <Icon icon="target" />
      </div>
      <h2>{formatThousand(impact.score)}</h2>
      <div className="card_infoicn">
        <h4 className="m-r-5">
          <Trans>Impact Score</Trans>
        </h4>
        <Tooltip tip={t("This score out of 100 represents the overall reach of the programs to date.")}>
          <Icon icon="info" />
        </Tooltip>
      </div>
      <Change change={impact.change} />
    </Panel.Body>
  </Panel>
);

const EventStatusGetting: React.FC = () => (
  <Grid>
    <Grid.Item md={6} lg={4}>
      <Panel>
        <Panel.LoaderBody loading className="tile_view" />
      </Panel>
    </Grid.Item>
    <Grid.Item md={6} lg={4}>
      <Panel>
        <Panel.LoaderBody loading className="tile_view" />
      </Panel>
    </Grid.Item>
    <Grid.Item md={12} lg={4}>
      <Panel>
        <Panel.LoaderBody loading className="tile_view" />
      </Panel>
    </Grid.Item>
  </Grid>
);

type EventStats = {
  stats: {
    events: EventsStats;
    rsvps: RsvpsStats;
    impact: ImpactStats;
  };
};

type EventStatusProps = {
  get: GetState<EventStats>;
};

const EventStatus: React.FC<EventStatusProps> = ({ get }) => {
  if (get.getting) {
    return <EventStatusGetting />;
  }

  if (get.error) {
    throw get.error;
  }

  return (
    <Grid>
      <Grid.Item md={6} lg={4}>
        <TotalEvents events={get.got.stats.events} />
      </Grid.Item>
      <Grid.Item md={6} lg={4}>
        <TotalRsvps rsvps={get.got.stats.rsvps} />
      </Grid.Item>
      <Grid.Item md={12} lg={4}>
        <Impact impact={get.got.stats.impact} />
      </Grid.Item>
    </Grid>
  );
};

export default EventStatus;
